import { curry } from '../../../utils/helpers.mjs';

function editionCreate(client, input) {
  return client.writeContract(input);
}
function editionV2WalletActionsCreate(client) {
  return {
    editionV2: {
      ...client.editionV2,
      createEdition: curry(editionCreate)(client)
    }
  };
}

export { editionCreate, editionV2WalletActionsCreate };
